export default "__VITE_ASSET__intqgx7W__"